







































































import { createComponent, computed } from "@vue/composition-api";
import { ComponentPropsOptions } from "@vue/composition-api/dist/component/componentProps";
import { NumericFieldProps } from "@web-components/types/NumericFieldProps";
import { useNumericFieldFunctions } from "@web-components/compositions/useNumericFieldFunctions";
import { usePreventNonNumeric } from "@web-components/compositions/usePreventNonNumeric";

//TODO: figure out how we can get the interface and props working together correctly
//It looks like props are always required with Vue 2, this will change with vue 3 , but for
//now we need to specify props & the interface
const props: ComponentPropsOptions<NumericFieldProps> = {
  min: {
    type: Number,
    required: false
  },
  max: {
    type: Number,
    required: true
  },
  value: {
    type: [Number, String],
    required: false
  }
};
export default createComponent({
  inheritAttrs: false,
  props,
  setup(props, context) {
    const validation = useNumericFieldFunctions(
      props as NumericFieldProps,
      context
    );

    const { onKeyDown } = usePreventNonNumeric(props.max);

    const disableIncrement = computed(() => {
      const number = Number(props.value || 0);
      return number >= props.max;
    });

    const disableDecrement = computed(
      () => Number(props.value || 0) <= props.min
    );

    const sendInputEvent = (number: number) => {
      context.emit("input", number);
      validation.inputValue.value = number;
    };

    const decrement = () => {
      const number = Number(props.value) - 1;
      sendInputEvent(number);
    };

    const increment = () => {
      const number = Number(props.value) + 1;
      sendInputEvent(number);
    };

    const onClick = (event: any) => {
      if (Number(event.target.value) === 0) {
        try {
          event.target.setSelectionRange(0, event.target.value.length);
        } catch {
          event.target.select();
        }
      }
    };

    return {
      ...validation,
      decrement,
      disableDecrement,
      disableIncrement,
      increment,
      onKeyDown,
      onClick
    };
  }
});
